import { HttpClient } from 'core/common/services';
import { isActiveSubscription, isChatSubscription } from '../../entities';
import { SubscriptionDtoMapper } from '../../mappers';
import { SubscriptionDto } from '../dto';
import { SubscriptionsServiceInterface } from './SubscriptionsServiceInterface';

export class SubscriptionsService implements SubscriptionsServiceInterface {
  constructor(private readonly httpClient: HttpClient) {}

  async getSubscriptions() {
    const dtoMapper = new SubscriptionDtoMapper();

    const { data } = await this.httpClient.get<{
      subscriptions: Array<SubscriptionDto>;
    }>('/payment-service/funnel/subscriptions');

    return data.subscriptions.map(dtoMapper.toEntity);
  }

  async isActiveSubscription(): Promise<boolean> {
    const subscriptions = await this.getSubscriptions();

    const activeSubscriptions = subscriptions.filter(
      (item) => !isChatSubscription(item) && isActiveSubscription(item),
    );

    return !!activeSubscriptions.length;
  }
}
